export default __webpack_public_path__ + "static/media/welcome.2944d812.svg";